import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: {
      value: _vm.value,
      size: "sm",
      persistent: "",
      "no-click-animation": "",
      title: _setup.dialogContent.title,
      "data-qa": "analyses_lpu_cards_request_error_dialog",
    },
    on: {
      input: function ($event) {
        return _setup.emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
              _vm._v("\n      " + _vm._s(_setup.dialogContent.text) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              VBtn,
              {
                attrs: {
                  color: "primary",
                  text: "",
                  "data-qa": "analyses_lpu_cards_request_error_reload",
                },
                on: { click: _setup.reloadPage },
              },
              [_vm._v("\n      Обновить\n    ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }